/**
 * プラン上限到達時のメール送信サービス
 */

import { supabase } from '../lib/supabase'

interface LimitReachedEmailParams {
  limitType: 'projects' | 'todos' | 'storage'
  maxAllowed: number
}

/**
 * プラン上限到達時にユーザーへメールを送信
 */
export async function sendLimitReachedEmail(params: LimitReachedEmailParams): Promise<boolean> {
  try {
    // 現在のユーザー情報を取得
    const { data: { user } } = await supabase.auth.getUser()
    if (!user?.email) {
      console.error('User email not found')
      return false
    }

    // ユーザープロフィールから名前を取得
    const { data: profile } = await supabase
      .from('user_profiles')
      .select('nickname')
      .eq('id', user.id)
      .single()

    // Edge Functionを呼び出し
    const { error } = await supabase.functions.invoke('send-limit-reached-email', {
      body: {
        userEmail: user.email,
        userName: profile?.nickname || undefined,
        limitType: params.limitType,
        currentPlan: 'free',
        maxAllowed: params.maxAllowed
      }
    })

    if (error) {
      console.error('Failed to send limit reached email:', error)
      return false
    }

    console.log('Limit reached email sent successfully')
    return true
  } catch (error) {
    console.error('Error sending limit reached email:', error)
    return false
  }
}
